









































































































import { isNumber } from 'lodash'
import Swal from 'sweetalert2'
import PosterUser from '../mixins/poster-user'
import { EvaluacionForm } from '../services/poster'
import Worker from './Worker.vue'

interface Data {
  clave: string | null
  text: string[] | any
  value: string | null
  titulo?: string
}

interface ElementoEvaluacion {
  criterio: string
  valor: number
}

interface EvaluacionComponetData {
  posterType: string
  dialog_: boolean
  elementosEvaluacion: ElementoEvaluacion[]
  valid: boolean
  showAlert: boolean
  radioRules: any[]
  fecha: any
}

export default PosterUser.extend({
  components: {
    Worker,
  },
  data(): EvaluacionComponetData {
    return {
      posterType: 'eval',
      dialog_: true,
      elementosEvaluacion: [
        {
          criterio:
            'Presenta de forma clara y argumentada el problema de investigación',
          valor: 0,
        },
        {
          criterio:
            'Presenta los referentes teóricos utilizados en el desarrollo de la investigación',
          valor: 0,
        },
        {
          criterio:
            'Muestra un diseño metodológico claro y coherente con los objetivos',
          valor: 0,
        },
        {
          criterio:
            'Presenta los resultados de manera precisa, clara y coherente',
          valor: 0,
        },
        {
          criterio: 'Muestra conclusiones y trabajos futuros',
          valor: 0,
        },
        {
          criterio: 'Desarrolla una presentación de manera creativa',
          valor: 0,
        },
      ],
      valid: false,
      showAlert: false,
      radioRules: [
        (v: any) => !!v || 'Seleccione un valor',
      ],
      fecha: {
        getDia: function () {
          const dia = new Date()
          return dia.getDate()
        },
        getMes: function () {
          const mes = new Date()
          const meses = [
            'enero',
            'febrero',
            'marzo',
            'abril',
            'mayo',
            'junio',
            'julio',
            'agosto',
            'septiembre',
            'octubre',
            'noviembre',
            'diciembre',
          ]
          return meses[mes.getMonth()]
        },
        getAnio: function () {
          const anio = new Date()
          return anio.getFullYear()
        },
      },
    }
  },

  computed: {
    form(): any {
      if (!this.poster) {
        return {}
      }
      const { elementosEvaluacion } = this as any
      let calificacion:number = [
        ...(elementosEvaluacion as ElementoEvaluacion[]).map(
          e => e.valor
        ),
      ].reduce((a: number, b: number) => a + b, 0) / 6
      calificacion = Number.parseFloat(calificacion.toFixed(2));
      return {
        calificacion,
        id_evaluador_poster: (this as any).poster.evaluacion
          .id_evaluador_poster,
      } as EvaluacionForm
    },

    postEvaluacion() {
      const { poster } = this
      return poster && (poster.estado === 'A' || poster.estado === 'N')
    },
  },

  methods: {
    async submit() {
    const valido = await (this as any).$refs.form.validate(); 
      if (!valido) {
        this.showAlert = true
        setTimeout(() => {
          this.showAlert = false
        }, 5000)
      } else {
        await this.sync()
        const { form, poster } = this
        try {
          const result = await this.$store.dispatch('poster/evaluacionPoster', {
            form,
            poster,
          })
          Swal.fire('Exito', result, 'success')
          ;(this as any).visible = false
        } catch (error) {
          Swal.fire('Error', 'No fue posible realizar cambios', 'error')
        }
      }
    },
  },
  watch: {
    /*values(v: any[]) {
      const { elementosEvaluacion } = this as any
      for (let i = 0; i < v.length; i++) {
        const valuesElemento = v[i]
        const total = valuesElemento.reduce((a: number, b: number) => a + b, 0)
        elementosEvaluacion[i].total = total / valuesElemento.length
      }
    },*/
    poster() {
      ;(this.$refs.form as any).reset()
      ;(this.$refs.form as any).resetValidation()
    },
  },
})
